import { useState } from 'react'

import {
  Link,
  useNavigate,
} from 'react-router-dom'
import {
  useSelector,
  useDispatch,
} from 'react-redux'

import {
  Flex,
  Button,
  IconButton,
} from '@chakra-ui/react'
import {
  HamburgerIcon,
  CloseIcon,
} from '@chakra-ui/icons'

import { logoutUser, reset } from '../../features/auth/authSlice'


import Logo1 from '../../assets/images/logo-header.png'


export default function Header() {

  const { user } = useSelector((state) => state.auth)

  const navigate = useNavigate()
  const dispatch = useDispatch()

  const onLogout = () => {
    dispatch(logoutUser())
    dispatch(reset())
    // changeDisplay('none')
    // navigate('/')
    window.location.href = '/';
  }

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
      <div className="container px-5">
        <a className="navbar-brand" href="/"><img src={Logo1} style={{height:'50px', width:'187.5px'}}/></a>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"><span className="navbar-toggler-icon"></span></button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
            <li className="nav-item"><a className="nav-link" href="/">Home</a></li>
            <span className="text-white mx-1 nav-link">&middot;</span>
            {
              user ? (
                <>
                  <li class="nav-item dropdown">
                      <a class="nav-link" id="navbarDropdownBlog" href="/myjourneys" role="button" aria-expanded="false">My journeys</a>
                      <ul class="dropdown-menu" aria-labelledby="navbarDropdownBlog">
                          <li><a class="dropdown-item" href="/myjourneys">My journey log</a></li>
                          <li><a class="dropdown-item" href="/myjourneys/insights">Insights</a></li>
                      </ul>
                  </li>
                  {
                    user.details.subscription.tier === 'creator' || user.details.subscription.tier === 'creator-courtesy' && (
                      <li className="nav-item"><a className="nav-link" href="/creator">Creator</a></li>
                    )
                  }

                  <li className="nav-item dropdown">
                    <a className="nav-link dropdown-toggle" id="navbarDropdownBlog" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">Logged in as: {user.email}</a>
                    <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdownBlog">
                      <li><a className="dropdown-item" href="/preferences">Account & preferences</a></li>
                      <li><a className="dropdown-item" onClick={onLogout}>Logout</a></li>
                    </ul>
                  </li>
                </>
              ) : (
                <>
                  <li className="nav-item"><a className="nav-link" href="/login">Login</a></li>
                  <li className="nav-item"><a className="nav-link" href="/register">Register</a></li>
                </>
              )
            }

          </ul>
        </div>
      </div>
    </nav>
  )
}